import { contactSearchDbName, contactDbName, orgTable, lxInfoTable } from './util/const';
import { api } from '@/api/api';
import { apis } from '@/config';
const buildLokiContactInfo = (contact, contactItemExtras) => {
    var _a, _b, _c, _d;
    const c = contact;
    if (contact.type === 'personal') {
        return {
            remark: c.remark || '',
            personalOrg: c.personalOrg || '',
            birthday: c.birthday || '',
            role: c.role || '',
            title: c.title || '',
            org: c.org || '',
            orgname: c.orgname || '',
            adrList: c.adrList || [],
            pref: (_a = c.pref) !== null && _a !== void 0 ? _a : 0,
            priority: (_b = c.priority) !== null && _b !== void 0 ? _b : 0,
            marked: (_c = c.marked) !== null && _c !== void 0 ? _c : false,
            tels: (contactItemExtras === null || contactItemExtras === void 0 ? void 0 : contactItemExtras.tels) || [],
            mobiles: (contactItemExtras === null || contactItemExtras === void 0 ? void 0 : contactItemExtras.mobiles) || [],
            faxes: (contactItemExtras === null || contactItemExtras === void 0 ? void 0 : contactItemExtras.faxes) || [],
        };
    }
    return {
        job: c.job || '',
        mobile: c.mobile || '',
        gender: c.gender || '',
        state: c.state || '',
        status: (_d = c.accountStatus) !== null && _d !== void 0 ? _d : 0,
        tel: c.tel || '',
        unitNames: c.unitNames || c.position || [],
        unitInfos: c.unitInfos || [],
        qyUnitIds: c.qyUnitIds || [],
    };
};
export const contactToLokiRow = (contact, contactItems) => {
    var _a, _b, _c;
    const enterpriseId = (_a = contact.enterpriseId) !== null && _a !== void 0 ? _a : -1;
    const _lokiKey = `${contact.id}_${enterpriseId}`;
    const accountName = (contact.type === 'personal' ? contact.accountName || '' : contact.displayEmail || contact.accountName || '').toLocaleLowerCase();
    const emailSet = new Set();
    const rawAccountName = (contact.accountName || '').toLocaleLowerCase();
    if (rawAccountName && rawAccountName !== accountName) {
        emailSet.add(rawAccountName);
    }
    const tels = [];
    const mobiles = [];
    const faxes = [];
    contactItems.forEach(item => {
        const val = item.contactItemVal || '';
        if (!val) {
            return;
        }
        switch (item.contactItemType) {
            case 'EMAIL': {
                const lower = val.toLocaleLowerCase();
                if (lower !== accountName) {
                    emailSet.add(lower);
                }
                break;
            }
            case 'TEL':
                tels.push(val);
                break;
            case 'MOBILE':
                mobiles.push(val);
                break;
            case 'FAX':
                faxes.push(val);
                break;
            default:
                break;
        }
    });
    return {
        _lokiKey,
        id: contact.id,
        accountName,
        emails: [...emailSet],
        contactName: contact.contactName || '',
        contactPYName: contact.contactPYName || '',
        contactPYLabelName: contact.contactPYLabelName || '',
        avatar: contact.avatar || '',
        avatarPendant: contact.avatarPendant || '',
        visibleCode: (_b = contact.visibleCode) !== null && _b !== void 0 ? _b : 0,
        type: contact.type || 'enterprise',
        enterpriseId,
        position: contact.position || [],
        remark: contact.remark || '',
        info: buildLokiContactInfo(contact, { tels, mobiles, faxes }),
        _lastUpdateTime: (_c = contact._lastUpdateTime) !== null && _c !== void 0 ? _c : 0,
    };
};
const orgToLokiRow = (org) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return ({
        id: org.id,
        orgName: org.orgName || '',
        orgPYName: org.orgPYName || '',
        type: (_a = org.type) !== null && _a !== void 0 ? _a : 0,
        orgRank: (_b = org.orgRank) !== null && _b !== void 0 ? _b : 0,
        visibleCode: (_c = org.visibleCode) !== null && _c !== void 0 ? _c : 0,
        originId: org.originId || '',
        enterpriseId: org.enterpriseId || -1,
        memberNum: (_d = org.memberNum) !== null && _d !== void 0 ? _d : 0,
        parent: org.parent || '',
        level: (_e = org.level) !== null && _e !== void 0 ? _e : 0,
        childrenCount: (_f = org.childrenCount) !== null && _f !== void 0 ? _f : 0,
        marked: (_g = org.marked) !== null && _g !== void 0 ? _g : 0,
        source: org.source || '',
        _lastUpdateTime: (_h = org._lastUpdateTime) !== null && _h !== void 0 ? _h : 0,
    });
};
const orgContactToLokiRow = (oc) => {
    var _a;
    const tc = oc;
    return {
        id: oc.id,
        contactId: oc.contactId,
        orgId: oc.orgId,
        type: oc.type || 'enterprise',
        enterpriseId: oc.enterpriseId || -1,
        rankNum: (_a = oc.rankNum) !== null && _a !== void 0 ? _a : 0,
        yunxinId: oc.yunxinId || undefined,
        imId: tc.imId || undefined,
        nickInTeam: tc.nickInTeam || undefined,
        joinTime: tc.joinTime || undefined,
        _lastUpdateTime: oc._lastUpdateTime || undefined,
    };
};
export const writeContactsToLoki = async (lokiApi, contacts, contactItems, _dbAccount) => {
    const dbRefer = {
        dbName: contactSearchDbName,
        tableName: 'contact',
        _dbAccount,
    };
    const itemMap = new Map();
    contactItems.forEach(item => {
        const list = itemMap.get(item.contactId) || [];
        list.push(item);
        itemMap.set(item.contactId, list);
    });
    const rows = contacts.map(contact => contactToLokiRow(contact, itemMap.get(contact.id) || []));
    if (!rows.length) {
        return;
    }
    await lokiApi.putAll(dbRefer, rows);
};
export const writeOrgsToLoki = async (lokiApi, orgs, _dbAccount) => {
    const dbRefer = {
        dbName: contactSearchDbName,
        tableName: 'org',
        _dbAccount,
    };
    const rows = orgs.map(orgToLokiRow);
    if (!rows.length) {
        return;
    }
    await lokiApi.putAll(dbRefer, rows);
};
export const deleteOldEnterpriseFromLoki = async (lokiApi, options) => {
    const { enterpriseId, _dbAccount } = options;
    await Promise.all([
        lokiApi.deleteByByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'contact',
            adCondition: {
                type: 'equals',
                field: 'enterpriseId',
                args: [enterpriseId],
            },
            _dbAccount,
        }),
        lokiApi.deleteByByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'org',
            adCondition: {
                type: 'equals',
                field: 'enterpriseId',
                args: [enterpriseId],
            },
            _dbAccount,
        }),
        lokiApi.deleteByByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'orgContact',
            adCondition: {
                type: 'equals',
                field: 'enterpriseId',
                args: [enterpriseId],
            },
            _dbAccount,
        }),
    ]);
};
export const deleteOldEnterpriseFromLokiByType = async (lokiApi, options) => {
    const { _dbAccount } = options;
    await Promise.all([
        lokiApi.deleteByByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'contact',
            adCondition: {
                type: 'equals',
                field: 'type',
                args: ['enterprise'],
            },
            _dbAccount,
        }),
        lokiApi.deleteByByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'org',
            adCondition: {
                type: 'below',
                field: 'type',
                args: [2000],
            },
            _dbAccount,
        }),
        lokiApi.deleteByByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'orgContact',
            adCondition: {
                type: 'equals',
                field: 'type',
                args: ['enterprise'],
            },
            _dbAccount,
        }),
    ]);
};
export const deleteOldEnterpriseContactsFromLoki = async (lokiApi, options) => {
    const { enterpriseId, _dbAccount } = options;
    await Promise.all([
        lokiApi.deleteByByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'contact',
            adCondition: {
                type: 'equals',
                field: 'enterpriseId',
                args: [enterpriseId],
            },
            _dbAccount,
        }),
        lokiApi.deleteByByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'orgContact',
            adCondition: {
                type: 'equals',
                field: 'enterpriseId',
                args: [enterpriseId],
            },
            _dbAccount,
        }),
    ]);
};
export const deleteAllEnterpriseFromLoki = async (lokiApi, _dbAccount) => {
    await Promise.all([
        lokiApi.deleteByByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'contact',
            adCondition: {
                type: 'equals',
                field: 'type',
                args: ['enterprise'],
            },
            _dbAccount,
        }),
        lokiApi.deleteByByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'org',
            adCondition: {
                type: 'aboveOrEqual',
                field: 'enterpriseId',
                args: [0],
            },
            _dbAccount,
        }),
        lokiApi.deleteByByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'orgContact',
            adCondition: {
                type: 'aboveOrEqual',
                field: 'enterpriseId',
                args: [0],
            },
            _dbAccount,
        }),
    ]);
};
export const writeOrgContactsToLoki = async (lokiApi, orgContacts, _dbAccount) => {
    if (!orgContacts.length) {
        return;
    }
    const dbRefer = {
        dbName: contactSearchDbName,
        tableName: 'orgContact',
        _dbAccount,
    };
    const rows = orgContacts.map(orgContactToLokiRow);
    await lokiApi.putAll(dbRefer, rows);
};
export const readOrgContactsByOrgId = async (lokiApi, orgId, _dbAccount) => {
    try {
        const result = await lokiApi.getByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'orgContact',
            adCondition: {
                type: 'equals',
                field: 'orgId',
                args: [orgId],
            },
            _dbAccount,
        });
        return result || [];
    }
    catch (e) {
        return [];
    }
};
export const deleteOrgContactsByOrgId = async (lokiApi, orgId, _dbAccount) => {
    await lokiApi.deleteByByRangeCondition({
        dbName: contactSearchDbName,
        tableName: 'orgContact',
        adCondition: {
            type: 'equals',
            field: 'orgId',
            args: [orgId],
        },
        _dbAccount,
    });
};
export const readOrgContactsByOrgIds = async (lokiApi, orgIds, _dbAccount) => {
    const resultMap = new Map();
    if (!orgIds.length) {
        return resultMap;
    }
    try {
        const rows = await lokiApi.getByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'orgContact',
            adCondition: {
                type: 'anyOf',
                field: 'orgId',
                args: [orgIds],
            },
            _dbAccount,
        });
        (rows || []).forEach(row => {
            const existing = resultMap.get(row.orgId) || [];
            existing.push(row);
            resultMap.set(row.orgId, existing);
        });
    }
    catch (e) {
    }
    return resultMap;
};
export const readQyOrgIdsByOrgIds = async (lokiApi, orgIds, _dbAccount) => {
    if (!orgIds.length) {
        return [];
    }
    try {
        const orgList = await lokiApi.getByRangeCondition({
            dbName: contactSearchDbName,
            tableName: orgTable,
            adCondition: {
                type: 'anyOf',
                field: 'id',
                args: [orgIds],
            },
            _dbAccount,
        });
        return orgList.map(item => item.originId);
    }
    catch (e) {
        console.error('[contact_sync_enterprise_loki] readQyOrgIdsByOrgIds', e);
    }
    return [];
};
export const readOrgInfoByOrgIds = async (lokiApi, orgIds, _dbAccount) => {
    var _a;
    const result = new Map();
    if (!orgIds.length) {
        return result;
    }
    try {
        const mainCompanyId = (_a = api.getSystemApi().getCurrentCompanyId(_dbAccount)) !== null && _a !== void 0 ? _a : -1;
        const orgList = await lokiApi.getByRangeCondition({
            dbName: contactSearchDbName,
            tableName: orgTable,
            adCondition: {
                type: 'anyOf',
                field: 'id',
                args: [orgIds],
            },
            _dbAccount,
        });
        orgList.forEach(org => {
            const enterpriseId = org.enterpriseId != null && org.enterpriseId !== -1 ? org.enterpriseId : mainCompanyId;
            result.set(org.id, { originId: org.originId, enterpriseId });
        });
    }
    catch (e) {
        console.error('[contact_sync_enterprise_loki] readOrgInfoByOrgIds', e);
    }
    return result;
};
export const writeLxInfoToLoki = async (lokiApi, rows, _dbAccount) => {
    if (!rows.length) {
        return;
    }
    await lokiApi.putAll({ dbName: contactSearchDbName, tableName: lxInfoTable, _dbAccount }, rows);
};
export const readLxInfoFromLoki = async (lokiApi, contactIds, _dbAccount) => {
    if (!contactIds.length) {
        return [];
    }
    try {
        const result = await lokiApi.getByRangeCondition({
            dbName: contactSearchDbName,
            tableName: lxInfoTable,
            adCondition: {
                type: 'anyOf',
                field: 'contactId',
                args: [contactIds],
            },
            _dbAccount,
        });
        return result || [];
    }
    catch (e) {
        return [];
    }
};
export const backfillLxInfoFromDexie = async (_dbAccount) => {
    try {
        const dexieApi = api.requireLogicalApi(apis.dexieDbApi);
        const lokiApi = api.requireLogicalApi(apis.dbMemoryApiImpl);
        const rows = await dexieApi.getByRangeCondition({
            dbName: contactDbName,
            tableName: lxInfoTable,
            _dbAccount,
        });
        if (!rows || rows.length === 0) {
            return false;
        }
        await writeLxInfoToLoki(lokiApi, rows, _dbAccount);
        console.warn('[contact_sync_enterprise_loki] backfillLxInfoFromDexie success, rows:', rows.length);
        return true;
    }
    catch (e) {
        console.error('[contact_sync_enterprise_loki] backfillLxInfoFromDexie error', e);
        return false;
    }
};
